import type { EnumProps } from "@/components/EnumBadge.tsx";
import { Trans } from "@lingui/react/macro";
import type { ServiceStatusEnum, VmStatusEnum } from "@warrenio/api-spec/spec.oats.gen";

export const vmStatuses: VmStatusEnum[] = ["creating", "running", "stopping", "stopped", "deleted"] as const;

/** @public */
export const serviceStatuses: ServiceStatusEnum[] = ["active", "deleted", "requested"] as const;

export const statusDescriptions: Record<VmStatusEnum | ServiceStatusEnum, EnumProps> = {
    creating: { label: <Trans comment="Virtual machine status">Creating</Trans>, color: "warning" },
    running: { label: <Trans comment="Virtual machine status">Running</Trans>, color: "success" },
    stopping: { label: <Trans comment="Virtual machine status">Stopping</Trans>, color: "warning" },
    stopped: { label: <Trans comment="Virtual machine status">Stopped</Trans>, color: "error" },
    deleted: { label: <Trans comment="Virtual machine status">Deleted</Trans>, color: "error" },
    active: { label: <Trans comment="Service status">Active</Trans>, color: "success" },
    requested: {
        // XXX: Is this service status actually encountered in real data? Leave untranslated for now.
        label: "Requested",
        color: "warning",
    },
};
